import React from "react";
import { useAuth } from "../../Context/AuthContext";
// import UserAnalysis from "../UserAnalysis/UserAnalysis";
import SuperAdminAnalysis from "../SuperAdminAnalysis/SuperAdminAnalysis";
import MyActivityDashboard from "../MyActivityDashboard/MyActivityDashboard";

const DashboardRouter = () => {
 const { user, isAdmin, isAssistant, isSuperAdmin } = useAuth();




  if (isAdmin || isAssistant || isSuperAdmin) {
    return <SuperAdminAnalysis />;
  
  }
 return <MyActivityDashboard />;
   
};

export default DashboardRouter;